import axios from 'axios';
import { envVarService } from './envVarService';

export const loginRequest = async (popup: boolean = false): Promise<any> => {
  const API_URL = await envVarService.getEnvVar('REACT_APP_API_URL');
  return axios.get(`${API_URL}/login`, {
    params: { popup }
  });
};

export const logoutRequest = async (): Promise<any> => {
  const API_URL = await envVarService.getEnvVar('REACT_APP_API_URL');
  return axios.get(`${API_URL}/logout`);
};

export const pollTokenRequest = async (nonce: string): Promise<any> => {
  const API_URL = await envVarService.getEnvVar('REACT_APP_API_URL');
  return axios.get(`${API_URL}/pollToken`, {
    params: { nonce },
    validateStatus: (status) => status === 200 || status === 204,
  });
};